import * as actionTypes from './actionTypes'

const getRoleList = filter => ({
    type: actionTypes.GET_ROLE_LIST_REQUEST,
    filter
})

const searchRoles = searchFields => ({
    type: actionTypes.ROLE_SEARCH_REQUEST,
    searchFields
})

const getRoleData = roleId => ({
    type: actionTypes.GET_ROLE_REQUEST,
    roleId
})

const createRole = roleData => ({
    type: actionTypes.CREATE_ROLE_REQUEST,
    roleData
})

const editRole = (roleId, roleData) => ({
    type: actionTypes.EDIT_ROLE_REQUEST,
    roleId,
    roleData
})

const deleteRole = roleId => ({
    type: actionTypes.DELETE_ROLE_REQUEST,
    roleId
})
const getPermissionsList = filter => ({
    type: actionTypes.GET_PERMISSION_LIST_REQUEST,
    filter
})

const resetRoleForm = () => ({
    type: actionTypes.RESET_ROLE_FORM
})

export default {
    getRoleList,
    searchRoles,
    getPermissionsList,
    getRoleData,
    createRole,
    editRole,
    deleteRole,
    resetRoleForm
}